// components/ErrorBoundary.js

import React, { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
    this.lastError = null
    this.errorLogTimeout = null
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })

    // 限制错误日志记录的频率
    if (this.lastError !== error) {
      this.lastError = error
      console.error('Unhandled error:', error)
      console.error('Error details:', errorInfo)

      // 设定一个短时间内的错误日志记录限制
      clearTimeout(this.errorLogTimeout)
      this.errorLogTimeout = setTimeout(() => {
        this.lastError = null
      }, 5000) // 5秒内同一个错误不会重复记录
    }
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义错误页面的内容
      return (
        <div>
          <h1>Something went wrong.</h1>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
